import Vue from 'vue'
import * as types from '../mutation-types'
import catalog from '../../api/catalog';

// initial state
const state = {
    loaded: false,
    categories: null,
    error: null
}

// getters
const getters = {
    loaded: state => state.loaded,
    categories: state => state.categories,
    error: state => state.error
}

// actions
const actions = {
    async updateItem({commit, dispatch}, data) {
        try {
            let resp = await catalog.updateItem(data)
            commit(types.CATALOG_GET_ITEMS, resp.data)
            commit(types.CATALOG_UPDATE_ITEM, null)
            dispatch('notification/updateError', null, {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
        }
    },
    async updateCategoryItems({commit, dispatch}, data) {
        try {
            let resp = await catalog.updateCategoryItems(data)
            commit(types.CATALOG_GET_ITEMS, resp.data)
            dispatch('notification/updateError', null, {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
        }
    },
    async loadItems({commit, dispatch}, locationId) {
        try {
            let resp = await catalog.items(locationId)
            commit(types.CATALOG_GET_ITEMS, resp.data)
            dispatch('notification/updateError', null, {root:true})
        } catch (error) {
            dispatch('notification/updateError', error, {root:true})
        }
    }
}

// mutations
const mutations = {
    [types.CATALOG_UPDATE_ITEM](state, data) {
        if(data) {
            state.editItem = data
        } else {
            state.editItem = null
        }
    },
    [types.CATALOG_GET_ITEMS](state, data) {
        Vue.set(state, 'categories', data);
    },
    [types.CATALOG_ERROR](state, error) {
        state.error = error
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
